import { render, staticRenderFns } from "./ChatInput.vue?vue&type=template&id=34c2398e&scoped=true&"
import script from "./ChatInput.vue?vue&type=script&lang=js&"
export * from "./ChatInput.vue?vue&type=script&lang=js&"
import style0 from "./ChatInput.vue?vue&type=style&index=0&id=34c2398e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c2398e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ChatInputFile: require('/home/circleci/repo/components/chat/ChatInputFile.vue').default})
